<div id="ds-roofline" [class.loggedIn]="loggedIn$ | async" class="flex">
  <div class="mover" #mover></div>
  <div #roofpeak></div>
</div>
